import { Price } from "@/types/checkout/checkout";

export const getTicketsAvailableForEvent = async (eventUuid: string): Promise<number> => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/tickets/get-tickets-left-for-event/${eventUuid}`, {
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    
    if (!response.ok) {
        throw new Error('Failed to fetch tickets available for event');
    }
    
    return response.json();
};

export const getTicketsAvailableForPrice = async (priceUuid: string): Promise<number> => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/tickets/get-tickets-left-for-price/${priceUuid}`, {
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    
    if (!response.ok) {
        throw new Error('Failed to fetch tickets available for price');
    }
    
    return response.json();
};

export const getTicketsAvailableForPrices = async (prices: Price[]): Promise<Price[]> => {
    const pricesWithTickets = await Promise.all(
        prices.map(async (price: Price) => {
            try {
                const ticketsAvailable = await getTicketsAvailableForPrice(price.uuid);
                return {
                    ...price,
                    tickets_available: ticketsAvailable || 0
                };
            } catch (error) {
                console.error('Error fetching tickets available:', error);
                return { ...price, tickets_available: 0 };
            }
        })
    );
    
    return pricesWithTickets;
}; 